export default defineNuxtRouteMiddleware((to) => {
  // Skip auth check if the page has auth: false in page meta
  if (to.meta.auth === false) {
    return;
  }

  const { loggedIn } = useUserSession();

  if (!loggedIn.value) {
    return navigateTo("/login");
  }
});
